if (!customElements.get('mobile-sticky-button')) {
  class MobileStickyButton extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.checkoutButtonWrapper = null;
      this._resizeHandler = null;
      this._resizeTimer = null;
      this._lastStickyState = null;
      this._initialized = false;
    }

    connectedCallback() {
      // two rafs so inline scripts finish moving things first
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (window.innerWidth <= 991) {
            this.init();
          }
        });
      });

      this._resizeHandler = () => {
        // debounce so resize doesnt thrash init/cleanup
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          if (window.innerWidth <= 991) {
            if (!this.observer) this.init();
          } else {
            this.cleanup();
          }
        }, 150);
      };
      window.addEventListener('resize', this._resizeHandler);
    }

    init() {
      this.checkoutButtonWrapper = this.querySelector('.checkout-button-wrapper');
      if (!this.checkoutButtonWrapper) return;

      // no transitions during setup or it flashes
      this.checkoutButtonWrapper.style.transition = 'none';

      // lock height so it holds the space when fixed
      var height = this.checkoutButtonWrapper.offsetHeight;
      if (height > 0) {
        this.style.minHeight = height + 'px';
      }

      // dont let the page scroll from the sticky bar
      this._onTouchMove = function(e) {
        if (this.checkoutButtonWrapper && this.checkoutButtonWrapper.classList.contains('sticky')) {
          e.preventDefault();
        }
      }.bind(this);
      this.checkoutButtonWrapper.addEventListener('touchmove', this._onTouchMove, { passive: false });

      this.setupIntersectionObserver();
      this._initialized = true;

      // transitions back on after a frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.checkoutButtonWrapper) {
            this.checkoutButtonWrapper.style.transition = '';
          }
        });
      });
    }

    setupIntersectionObserver() {
      if (!this.checkoutButtonWrapper || this.observer) return;

      var self = this;
      var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var shouldBeSticky = false;

          if (entry.isIntersecting) {
            // placeholder in view, button sits in normal flow
            shouldBeSticky = false;
          } else {
            // not in view, work out which side
            var rect = entry.target.getBoundingClientRect();
            if (rect.top >= window.innerHeight) {
              // below the fold, havent scrolled to it yet
              shouldBeSticky = true;
            } else {
              // scrolled past it, hide the sticky
              shouldBeSticky = false;
            }
          }

          // only touch the dom when the state changed
          if (self._lastStickyState !== shouldBeSticky) {
            self._lastStickyState = shouldBeSticky;
            var wrapper = entry.target.querySelector('.checkout-button-wrapper');
            if (wrapper) {
              if (shouldBeSticky) {
                wrapper.classList.add('sticky');
              } else {
                wrapper.classList.remove('sticky');
              }
            }
          }
        });
      }, options);

      // observe the placeholder, not the button wrapper
      this.observer.observe(this);
    }

    cleanup() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this._lastStickyState = null;
      if (this.checkoutButtonWrapper) {
        this.checkoutButtonWrapper.classList.remove('sticky');
        this.checkoutButtonWrapper.style.transition = '';
        if (this._onTouchMove) {
          this.checkoutButtonWrapper.removeEventListener('touchmove', this._onTouchMove);
        }
      }
      this._onTouchMove = null;
      this.style.minHeight = '';
      this._initialized = false;
    }

    disconnectedCallback() {
      this.cleanup();
      clearTimeout(this._resizeTimer);
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler);
        this._resizeHandler = null;
      }
    }
  }
  customElements.define('mobile-sticky-button', MobileStickyButton);
}
